export enum AccountCreationError {
  NoError,
  InvalidCode,
  ExpiredCode,
  AccountData,
  GeneralError
}

const cognitoInvalidCodeException = 'Invalid verification code'
const cognitoExpiredCodeException = 'Expired'

export const CP_INVALID_CODE_MESSAGE =
  'Invalid verification code. Request new code.'
export const CP_GENERAL_ERROR_MESSAGE =
  'Something went wrong. Please try creating your account later or call support at 888-410-6988 (8:00am – 8:00pm ET, Mon-Fri).'

export const CP_ACCOUNT_DATA_ERROR_MESSAGE =
  'An error occurred saving account data. Please try again.'

export function getCorrectError(error?: string | null): AccountCreationError {
  if (error) {
    if (error.includes(cognitoInvalidCodeException)) {
      return AccountCreationError.InvalidCode
    } else if (error.includes(cognitoExpiredCodeException)) {
      return AccountCreationError.ExpiredCode
    } else {
      return AccountCreationError.GeneralError
    }
  } else {
    return AccountCreationError.NoError
  }
}
